export const formatCountry = (countryValue) => {
    let fixedList = [];
    const selectedCountrySet = new Set(countryValue.map(sc => sc.value));

    // Special case: if "World" is selected, ignore all others.
    if (selectedCountrySet.has('World')) {
        return [{ value: "World", label: "World" }];
    }

    // Helper to add countries only if they’re not already present.
    const addUniqueCountries = (countriesArray) => {
        countriesArray.forEach(countryObj => {
            if (!fixedList.some(item => item.value === countryObj.value)) {
                fixedList.push(countryObj);
            }
        });
    };

    if (selectedCountrySet.has('OECD')) {
        addUniqueCountries([
            { value: "AUSTRALIA", label: "Australia" },
            { value: "AUSTRIA", label: "Austria" },
            { value: "BELGIUM", label: "Belgium" },
            { value: "CANADA", label: "Canada" },
            { value: "CHILE", label: "Chile" },
            { value: "COLOMBIA", label: "Colombia" },
            { value: "COSTARICA", label: "Costa Rica" },
            { value: "CZECHIA", label: "Czechia" },
            { value: "DENMARK", label: "Denmark" },
            { value: "ESTONIA", label: "Estonia" },
            { value: "FINLAND", label: "Finland" },
            { value: "FRANCE", label: "France" },
            { value: "GERMANY", label: "Germany" },
            { value: "GREECE", label: "Greece" },
            { value: "HUNGARY", label: "Hungary" },
            { value: "ICELAND", label: "Iceland" },
            { value: "IRELAND", label: "Ireland" },
            { value: "ISRAEL", label: "Israel" },
            { value: "ITALY", label: "Italy" },
            { value: "JAPAN", label: "Japan" },
            { value: "LATVIA", label: "Latvia" },
            { value: "LITHUANIA", label: "Lithuania" },
            { value: "MEXICO", label: "Mexico" },
            { value: "NETHERLANDS", label: "Netherlands (Kingdom of the)" },
            { value: "NEWZEALAND", label: "New Zealand" },
            { value: "NORWAY", label: "Norway" },
            { value: "POLAND", label: "Poland" },
            { value: "PORTUGAL", label: "Portugal" },
            { value: "KOREA", label: "Republic of Korea (ROK)" },
            { value: "SLOVAKIA", label: "Slovakia" },
            { value: "SLOVENIA", label: "Slovenia" },
            { value: "SPAIN", label: "Spain" },
            { value: "SWEDEN", label: "Sweden" },
            { value: "SWITZERLAND", label: "Switzerland" },
            { value: "TURKEY", label: "Türkiye" },
            { value: "TURKIYE", label: "Türkiye" },
            { value: "UK", label: "United Kingdom of Great Britain and Northern Ireland (UK)" },
            { value: "USA", label: "United States of America (USA)" }
        ]);
    }
    if (selectedCountrySet.has('APAC')) {
        addUniqueCountries([
            { value: "AUSTRALIA", label: "Australia" },
            { value: "CHINA", label: "China" },
            { value: "INDIA", label: "India" },
            { value: "INDONESIA", label: "Indonesia" },
            { value: "JAPAN", label: "Japan" },
            { value: "MALAYSIA", label: "Malaysia" },
            { value: "MONGOLIA", label: "Mongolia" },
            { value: "NEPAL", label: "Nepal" },
            { value: "NEWZEALAND", label: "New Zealand" },
            { value: "PAPUANEWGUINEA", label: "Papua New Guinea" },
            { value: "PHILIPPINES", label: "Philippines" },
            { value: "KOREA", label: "Republic of Korea (ROK)" },
            { value: "THAILAND", label: "Thailand" },
            { value: "VIETNAM", label: "Viet Nam" }
        ]);
    }
    if (selectedCountrySet.has('EMEA')) {
        addUniqueCountries([
            { value: "ALBANIA", label: "Albania" },
            { value: "ALGERIA", label: "Algeria" },
            { value: "ARMENIA", label: "Armenia" },
            { value: "AUSTRIA", label: "Austria" },
            { value: "BELARUS", label: "Belarus" },
            { value: "BELGIUM", label: "Belgium" },
            { value: "BOSNIAHERZEGOVINA", label: "Bosnia and Herzegovina" },
            { value: "BULGARIA", label: "Bulgaria" },
            { value: "BURUNDI", label: "Burundi" },
            { value: "CROATIA", label: "Croatia" },
            { value: "CYPRUS", label: "Cyprus" },
            { value: "CZECHIA", label: "Czechia" },
            { value: "DENMARK", label: "Denmark" },
            { value: "EGYPT", label: "Egypt" },
            { value: "ESTONIA", label: "Estonia" },
            { value: "ETHIOPIA", label: "Ethiopia" },
            { value: "FAROEISLANDS", label: "Faroe Islands" },
            { value: "FRANCE", label: "France" },
            { value: "GEORGIA", label: "Georgia" },
            { value: "GERMANY", label: "Germany" },
            { value: "GREECE", label: "Greece" },
            { value: "GREENLAND", label: "Greenland" },
            { value: "HUNGARY", label: "Hungary" },
            { value: "ICELAND", label: "Iceland" },
            { value: "IRAN", label: "Iran (Islamic Republic of)" },
            { value: "IRELAND", label: "Ireland" },
            { value: "ISRAEL", label: "Israel" },
            { value: "ITALY", label: "Italy" },
            { value: "JORDAN", label: "Jordan" },
            { value: "KENYA", label: "Kenya" },
            { value: "LATVIA", label: "Latvia" },
            { value: "LITHUANIA", label: "Lithuania" },
            { value: "MADAGASCAR", label: "Madagascar" },
            { value: "MALAWI", label: "Malawi" },
            { value: "MOROCCO", label: "Morocco" },
            { value: "NETHERLANDS", label: "Netherlands (Kingdom of the)" },
            { value: "NIGERIA", label: "Nigeria" },
            { value: "NORTHMACEDONIA", label: "North Macedonia" },
            { value: "NORWAY", label: "Norway" },
            { value: "POLAND", label: "Poland" },
            { value: "PORTUGAL", label: "Portugal" },
            { value: "ROMANIA", label: "Romania" },
            { value: "RUSSIA", label: "Russian Federation" },
            { value: "ARABIA", label: "Saudi Arabia" },
            { value: "SERBIA", label: "Serbia" },
            { value: "SLOVAKIA", label: "Slovakia" },
            { value: "SLOVENIA", label: "Slovenia" },
            { value: "SOUTHAFRICA", label: "South Africa" },
            { value: "SPAIN", label: "Spain" },
            { value: "SWEDEN", label: "Sweden" },
            { value: "SWITZERLAND", label: "Switzerland" },
            { value: "TAJIKISTAN", label: "Tajikistan" },
            { value: "TUNISIA", label: "Tunisia" },
            { value: "TURKEY", label: "Türkiye" },
            { value: "TURKIYE", label: "Türkiye" },
            { value: "UKRAINE", label: "Ukraine" },
            { value: "UK", label: "United Kingdom of Great Britain and Northern Ireland (UK)" },
            { value: "YEMEN", label: "Yemen" }
        ]);
    }
    if (selectedCountrySet.has('LATAM')) {
        addUniqueCountries([
            { value: "ARGENTINA", label: "Argentina" },
            { value: "BOLIVIA", label: "Bolivia" },
            { value: "BRAZIL", label: "Brazil" },
            { value: "CHILE", label: "Chile" },
            { value: "COLOMBIA", label: "Colombia" },
            { value: "COSTARICA", label: "Costa Rica" },
            { value: "ECUADOR", label: "Ecuador" },
            { value: "ELSALVADOR", label: "El Salvador" },
            { value: "GUATEMALA", label: "Guatemala" },
            { value: "HONDURAS", label: "Honduras" },
            { value: "MEXICO", label: "Mexico" },
            { value: "NICARAGUA", label: "Nicaragua" },
            { value: "PERU", label: "Peru" },
            { value: "VENEZUELA", label: "Venezuela" }
        ]);
    }
    if (selectedCountrySet.has('NA')) {
        addUniqueCountries([
            { value: "CANADA", label: "Canada" },
            { value: "CARIBBEANISLANDS", label: "Caribbean Islands" },
            { value: "USA", label: "United States of America (USA)" }
        ]);
    }
    if (selectedCountrySet.has('Africa')) {
        addUniqueCountries([
            { value: "ALGERIA", label: "Algeria" },
            { value: "BURUNDI", label: "Burundi" },
            { value: "EGYPT", label: "Egypt" },
            { value: "ETHIOPIA", label: "Ethiopia" },
            { value: "KENYA", label: "Kenya" },
            { value: "MADAGASCAR", label: "Madagascar" },
            { value: "MALAWI", label: "Malawi" },
            { value: "MOROCCO", label: "Morocco" },
            { value: "NIGERIA", label: "Nigeria" },
            { value: "SOUTHAFRICA", label: "South Africa" },
            { value: "TUNISIA", label: "Tunisia" }
        ]);
    }
    if (selectedCountrySet.has('Americas')) {
        addUniqueCountries([
            { value: "ARGENTINA", label: "Argentina" },
            { value: "BOLIVIA", label: "Bolivia" },
            { value: "BRAZIL", label: "Brazil" },
            { value: "CANADA", label: "Canada" },
            { value: "CARIBBEANISLANDS", label: "Caribbean Islands" },
            { value: "CHILE", label: "Chile" },
            { value: "COLOMBIA", label: "Colombia" },
            { value: "COSTARICA", label: "Costa Rica" },
            { value: "ECUADOR", label: "Ecuador" },
            { value: "ELSALVADOR", label: "El Salvador" },
            { value: "GREENLAND", label: "Greenland" },
            { value: "GUATEMALA", label: "Guatemala" },
            { value: "HONDURAS", label: "Honduras" },
            { value: "MEXICO", label: "Mexico" },
            { value: "NICARAGUA", label: "Nicaragua" },
            { value: "PERU", label: "Peru" },
            { value: "USA", label: "United States of America (USA)" },
            { value: "VENEZUELA", label: "Venezuela" }
        ]);
    }
    if (selectedCountrySet.has('Asia')) {
        addUniqueCountries([
            { value: "ARMENIA", label: "Armenia" },
            { value: "CHINA", label: "China" },
            { value: "GEORGIA", label: "Georgia" },
            { value: "INDIA", label: "India" },
            { value: "INDONESIA", label: "Indonesia" },
            { value: "IRAN", label: "Iran (Islamic Republic of)" },
            { value: "ISRAEL", label: "Israel" },
            { value: "JAPAN", label: "Japan" },
            { value: "JORDAN", label: "Jordan" },
            { value: "MALAYSIA", label: "Malaysia" },
            { value: "MONGOLIA", label: "Mongolia" },
            { value: "NEPAL", label: "Nepal" },
            { value: "PHILIPPINES", label: "Philippines" },
            { value: "KOREA", label: "Republic of Korea (ROK)" },
            { value: "ARABIA", label: "Saudi Arabia" },
            { value: "TAJIKISTAN", label: "Tajikistan" },
            { value: "THAILAND", label: "Thailand" },
            { value: "TURKEY", label: "Türkiye" },
            { value: "TURKIYE", label: "Türkiye" },
            { value: "VIETNAM", label: "Viet Nam" },
            { value: "YEMEN", label: "Yemen" }
        ]);
    }
    if (selectedCountrySet.has('Europe')) {
        addUniqueCountries([
            { value: "ALBANIA", label: "Albania" },
            { value: "AUSTRIA", label: "Austria" },
            { value: "BELARUS", label: "Belarus" },
            { value: "BELGIUM", label: "Belgium" },
            { value: "BOSNIAHERZEGOVINA", label: "Bosnia and Herzegovina" },
            { value: "BULGARIA", label: "Bulgaria" },
            { value: "CROATIA", label: "Croatia" },
            { value: "CYPRUS", label: "Cyprus" },
            { value: "CZECHIA", label: "Czechia" },
            { value: "DENMARK", label: "Denmark" },
            { value: "ESTONIA", label: "Estonia" },
            { value: "FAROEISLANDS", label: "Faroe Islands" },
            { value: "FRANCE", label: "France" },
            { value: "GERMANY", label: "Germany" },
            { value: "GREECE", label: "Greece" },
            { value: "HUNGARY", label: "Hungary" },
            { value: "ICELAND", label: "Iceland" },
            { value: "IRELAND", label: "Ireland" },
            { value: "ITALY", label: "Italy" },
            { value: "LATVIA", label: "Latvia" },
            { value: "LITHUANIA", label: "Lithuania" },
            { value: "NORTHMACEDONIA", label: "North Macedonia" },
            { value: "NORWAY", label: "Norway" },
            { value: "POLAND", label: "Poland" },
            { value: "PORTUGAL", label: "Portugal" },
            { value: "ROMANIA", label: "Romania" },
            { value: "RUSSIA", label: "Russian Federation" },
            { value: "SERBIA", label: "Serbia" },
            { value: "SLOVAKIA", label: "Slovakia" },
            { value: "SLOVENIA", label: "Slovenia" },
            { value: "SPAIN", label: "Spain" },
            { value: "SWEDEN", label: "Sweden" },
            { value: "SWITZERLAND", label: "Switzerland" },
            { value: "NETHERLANDS", label: "Netherlands (Kingdom of the)" },
            { value: "UKRAINE", label: "Ukraine" },
            { value: "UK", label: "United Kingdom of Great Britain and Northern Ireland (UK)" }
        ]);
    }
    if (selectedCountrySet.has('Oceania')) {
        addUniqueCountries([
            { value: "AUSTRALIA", label: "Australia" },
            { value: "NEWZEALAND", label: "New Zealand" },
            { value: "PAPUANEWGUINEA", label: "Papua New Guinea" }
        ]);
    }

    // Return fixedList if any countries have been added, otherwise default to countryValue.
    return fixedList.length ? fixedList : countryValue;
};

export const fixCountryName = (countryName) => {
    let fixedName;

    if (typeof countryName !== "string") return

    if (countryName === "COSTARICA") {
        fixedName = "Costa Rica";
    } else if (countryName === "ELSALVADOR") {
        fixedName = "El Salvador";
    } else if (countryName === "NEWZEALAND") {
        fixedName = "New Zealand";
    } else if (countryName === "UK") {
        fixedName = "United Kingdom of Great Britain and Northern Ireland (UK)";
    } else if (countryName === "USA") {
        fixedName = "United States of America (USA)";
    } else if (countryName === "TURKIYE") {
        fixedName = "Türkeye";
    } else if (countryName === "RUSSIANFEDERATION") {
        fixedName = "Russian Federation";
    } else if (countryName === "PAPUANEWGUINEA") {
        fixedName = "Papua New Guinea";
    } else if (countryName === "ROK") {
        fixedName = "Republic of Korea (ROK)";
    } else if (countryName === "NORTHMACEDONIA") {
        fixedName = "North Macedonia";
    } else if (countryName === "BOSNIAHERZEGOVINA") {
        fixedName = "Bosnia & Herzegovina";
    } else if (countryName === "SAUDIARABIA") {
        fixedName = "Saudi Arabia";
    } else if (countryName === "VIETNAM") {
        fixedName = "Viet Nam";
    } else if (countryName === "SOUTHAFRICA") {
        fixedName = "South Africa";
    } else if (countryName === "FAROEISLANDS") {
        fixedName = "Faroe Islands";
    } else if (countryName === "CARIBBEANISLANDS") {
        fixedName = "Caribbean Islands";
    } else if (countryName === "IRAN") {
        fixedName = "Iran (Islamic Republic of)";
    } else if (countryName === "NETHERLANDS") {
        fixedName = "Netherlands (Kingdom of the)";
    } else if (countryName === "OECD") {
        fixedName = "OECD - Organization For Economic Co-operation and Development";
    } else if (countryName === "APAC") {
        fixedName = "APAC - Asia Pacific";
    } else if (countryName === "EMEA") {
        fixedName = "EMEA - Europe, Middle East and Africa";
    } else if (countryName === "LATAM") {
        fixedName = "LATAM - Latin America";
    } else if (countryName === "NA") {
        fixedName = "NA - North America";
    } else {
        fixedName = countryName.slice(0, 1).toUpperCase() + countryName.slice(1).toLowerCase();
    }

    return fixedName;
}

export const fixCountryNameMap = (countryName) => {
    if (typeof countryName !== "string") return;

    const normalizedDataName = countryName.replace(/\s+/g, '').toUpperCase();

    const abbreviationMapping = {
        "UK": "United Kingdom",
        "USA": "United States of America",
        "CZECHREP": "Czechia",
        "DEMOCRATICREPUBLICOFTHECONGO": "Democratic Republic of the Congo",
        "REPUBLICOFTHECONGO": "Republic of the Congo",
        "ESWATINI": "eSwatini",
        "REPUBLICOFSERBIA": "Republic of Serbia",
        "SOUTHKOREA": "South Korea",
        "NORTHKOREA": "North Korea",
        "SOUTHAFRICA": "South Africa",
        "NEWZEALAND": "New Zealand",
        "PAPUANEWGUINEA": "Papua New Guinea",
        "SIERRALEONE": "Sierra Leone",
        "BAHAMAS": "The Bahamas",
        "GUINEABISSAU": "Guinea-Bissau",
        "COSTARICA": "Costa Rica",
        "ELSALVADOR": "El Salvador",
        "SAOTOMEANDPRINCIPE": "São Tomé and Príncipe",
        "CABOVERDE": "Cape Verde",
        "IVORYCOAST": "Ivory Coast",
        "CENTRALAFRICANREPUBLIC": "Central African Republic",
        "SOUTHSUDAN": "South Sudan",
        "EQUATORIALGUINEA": "Equatorial Guinea",
        "BURKINAFASO": "Burkina Faso",
        "GUINEABISSAU": "Guinea-Bissau",
        "BOSNIAHERZEGOVINA": "Bosnia and Herzegovina",
        "NORTHMACEDONIA": "North Macedonia",
        "SAINTVINCENTANDTHEGRENADINES": "Saint Vincent and the Grenadines",
        "TRINIDADANDTOBAGO": "Trinidad and Tobago",
        "SOLOMONISLANDS": "Solomon Islands",
        "MARSHALLISLANDS": "Marshall Islands",
        "EASTTIMOR": "East Timor",
        "NORTHERNCYPRUS": "Northern Cyprus",
        "TIMORLESTE": "East Timor",
    };

    if (abbreviationMapping[normalizedDataName]) {
        return abbreviationMapping[normalizedDataName];
    }

    const geojsonNames = [
        "Costa Rica", "Nicaragua", "Haiti", "Dominican Republic", "El Salvador",
        "Guatemala", "Cuba", "Honduras", "United States of America", "Canada",
        "Mexico", "Belize", "Panama", "Greenland", "The Bahamas",
        "Trinidad and Tobago", "Puerto Rico", "Jamaica", "Indonesia",
        "Malaysia", "Cyprus", "India", "China", "Israel", "Palestine",
        "Lebanon", "Syria", "South Korea", "North Korea", "Bhutan",
        "Oman", "Uzbekistan", "Kazakhstan", "Tajikistan", "Mongolia",
        "Vietnam", "Cambodia", "United Arab Emirates", "Georgia",
        "Azerbaijan", "Turkey", "Laos", "Kyrgyzstan", "Armenia",
        "Iraq", "Iran", "Qatar", "Saudi Arabia", "Pakistan", "Thailand",
        "Kuwait", "East Timor", "Brunei", "Myanmar", "Bangladesh",
        "Afghanistan", "Turkmenistan", "Jordan", "Nepal", "Yemen",
        "Northern Cyprus", "Philippines", "Sri Lanka", "Japan", "Chile",
        "Bolivia", "Peru", "Argentina", "Suriname", "Guyana", "Brazil",
        "Uruguay", "Ecuador", "Colombia", "Paraguay", "Venezuela",
        "Falkland Islands", "Ethiopia", "South Sudan", "Somalia",
        "Kenya", "Malawi", "United Republic of Tanzania", "Somaliland",
        "Morocco", "Western Sahara", "Republic of the Congo",
        "Democratic Republic of the Congo", "Namibia", "South Africa",
        "Libya", "Tunisia", "Zambia", "Sierra Leone", "Guinea",
        "Liberia", "Central African Republic", "Sudan", "Djibouti",
        "Eritrea", "Ivory Coast", "Mali", "Senegal", "Nigeria",
        "Benin", "Angola", "Botswana", "Zimbabwe", "Chad", "Algeria",
        "Mozambique", "eSwatini", "Burundi", "Rwanda", "Uganda",
        "Lesotho", "Cameroon", "Gabon", "Niger", "Burkina Faso",
        "Togo", "Ghana", "Guinea-Bissau", "Egypt", "Mauritania",
        "Equatorial Guinea", "Gambia", "Madagascar", "France",
        "Ukraine", "Belarus", "Lithuania", "Russia", "Czechia",
        "Germany", "Estonia", "Latvia", "Norway", "Sweden", "Finland",
        "Luxembourg", "Belgium", "North Macedonia", "Albania", "Kosovo",
        "Spain", "Denmark", "Romania", "Hungary", "Slovakia",
        "Poland", "Ireland", "United Kingdom", "Greece", "Austria",
        "Italy", "Switzerland", "Netherlands", "Republic of Serbia",
        "Croatia", "Slovenia", "Bulgaria", "Montenegro", "Bosnia and Herzegovina",
        "Portugal", "Moldova", "Iceland", "Papua New Guinea", "Australia",
        "Fiji", "New Zealand", "New Caledonia", "Solomon Islands",
        "Vanuatu", "French Southern and Antarctic Lands"
    ];

    const normalizedGeojsonNamesMap = {};
    for (const name of geojsonNames) {
        const normalizedGeoName = name.replace(/\s+/g, '').toUpperCase();
        normalizedGeojsonNamesMap[normalizedGeoName] = name;
    }

    const geojsonName = normalizedGeojsonNamesMap[normalizedDataName];
    if (geojsonName) {
        return geojsonName;
    }

    for (const [normalizedGeoName, actualName] of Object.entries(normalizedGeojsonNamesMap)) {
        if (normalizedGeoName.includes(normalizedDataName)) {
            return actualName;
        }
    }

    return (
        countryName.charAt(0).toUpperCase() +
        countryName.slice(1).toLowerCase().replace(/([A-Z])/g, ' $1').trim()
    );
};